import { render, staticRenderFns } from "./report-ingress-component.vue?vue&type=template&id=4fb05f88&scoped=true&"
import script from "./report-ingress-component.vue?vue&type=script&lang=js&"
export * from "./report-ingress-component.vue?vue&type=script&lang=js&"
import style0 from "./report-ingress-component.vue?vue&type=style&index=0&id=4fb05f88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb05f88",
  null
  
)

export default component.exports